import type { AxiosInstance } from 'axios'
import axiosClient from 'axios'
import type { ApiOptions } from '~/types/util'

export default defineNuxtPlugin(nuxtApp => {
    const toolsApiHost = nuxtApp.$config.public.toolsApiHost as string

    if (!toolsApiHost) {
        console.warn('[toolsApi] TOOLS_API_HOST is not set. API calls will fail.')
    }

    const toolsApi = (options: ApiOptions = {}) => {
        options.headers = options.headers || {
            'Content-Type': `application/json`,
            'Accept': `application/json`,
            'API-Version': `2024-07-31`
        }

        if (options.version) {
            options.headers[`API-Version`] = options.version
        }

        const axios: AxiosInstance = axiosClient.create({
            baseURL: toolsApiHost,
            headers: options.headers
        })

        return axios
    }

    return {
        provide: {
            toolsApi
        }
    }
})
